import React from 'react';

const Footer = () => {
    return (
        <div>
            <p><small>Copy right @ all right regard by me</small></p>
        </div>
    );
};

export default Footer;